import Footer from '@/components/Footer';
import Navbar from '@/components/Navbar';
import styles from './FAQs.module.css';
import FaqContainer from '@/components/FAQArea/FaqContainer';

interface FAQsProps {}

const FAQs = (props: FAQsProps) => {

	return (
		<div className={styles.main_home_container}>
			<Navbar className={styles.navDivider}/>

			<main className={styles.mainContent}>
				<div className={styles.faq_area}>
					<FaqContainer />
				</div>
			</main>

			<Footer />
		</div>
	);
};

export default FAQs;
